import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {
  IDepartamento,
  IGetInformacionPerfilUsuario,
  IMunicipio,
  IPais,
  ITipoIdentificacion,
  PortalUsuarioEmpresaDto,
  RegistrarUsuarioRequest
} from "../../../shared/interfaces/seguridad";
import {TipoIdentificacionService} from "../../../services/tipoIdentificacion.service";
import {PaisService} from "../../../services/pais.service";
import {DepartamentoService} from "../../../services/departamento.service";
import {MunicipioService} from "../../../services/municipio.service";
import {MessageService} from "primeng/api";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {PortalUsuarioService} from "../../../services/portalUsuario.service";
import {
  ButtonColumnType,
  CustomTableComponent,
  DataColumnType,
  FormGroupErrorMessageComponent,
  ICustomTable,
  LoadingPanelService,
  noWhitespaceValidator,AlertIcon,
  Utils,AlertService
} from "lib-base";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {ButtonDirective} from "primeng/button";
import {CalendarModule} from "primeng/calendar";
import {DropdownModule} from "primeng/dropdown";
import {FileUpload, FileUploadHandlerEvent, FileUploadModule} from "primeng/fileupload";
import {InputNumberModule} from "primeng/inputnumber";
import {InputTextModule} from "primeng/inputtext";
import {DatePipe, NgIf, NgTemplateOutlet} from "@angular/common";
import {firstValueFrom, forkJoin, lastValueFrom} from "rxjs";
import {AvatarModule} from "primeng/avatar";
import {DividerModule} from "primeng/divider";
import {SkeletonModule} from "primeng/skeleton";
import {PortalUsuarioEmpresaService} from "../../../services/portalUsuarioEmpresa.service";
import {DialogModule} from "primeng/dialog";
import { TooltipModule } from 'primeng/tooltip';
import { FirmaElectronicaTokenService } from '../../../services/firmaElectronicaToken.service';

@Component({
  selector: 'app-profile-form',
  standalone: true,
  imports: [
    ButtonDirective,
    CalendarModule,
    DropdownModule,
    FileUploadModule,
    FormsModule,
    InputNumberModule,
    InputTextModule,
    NgIf, FormGroupErrorMessageComponent, CustomTableComponent,
    ReactiveFormsModule,
    TranslatePipe, DatePipe, AvatarModule, DividerModule,
    SkeletonModule, NgTemplateOutlet, DialogModule,
    TooltipModule 
  ],
  templateUrl: './profile-form.component.html',
  styleUrl: './profile-form.component.scss'
})
export class ProfileFormComponent implements OnInit, AfterViewInit {
  form !: FormGroup;
  empresaCreate !: FormGroup;
  tipoIdentificaciones: ITipoIdentificacion[] = [];
  ignoreTipoIdentificacion: string[] = ['NIT', 'TI', 'RC'];
  paises: IPais[] = [];
  modoEdicion: boolean = false;
  loading: boolean = false;
  openModal: boolean = false;
  departamentos: IDepartamento[] = [];
  municipios: IMunicipio[] = [];
  infoProfile!: IGetInformacionPerfilUsuario;
  propsTable!: ICustomTable;
  _translations: any = {};
  archivo?: File = undefined;
  readonly uploadFileSize: number = 1024 * 1024
  invalidSize = false;
  requieredFile = false;
  titleModal:string = '';
  private idEmpresaSelected:number | undefined;
  usuarioTieneFirmaActiva: boolean = false;

  @ViewChild(CustomTableComponent) empresasTable!: CustomTableComponent;

  constructor(private _ti: TipoIdentificacionService,
              private _p: PaisService, private _fb: FormBuilder,
              private _d: DepartamentoService, private _m: MunicipioService,
              private _ms: MessageService,
              private _t: TranslateService,
              private _pu: PortalUsuarioService,
              private _portalEmpService: PortalUsuarioEmpresaService,
              private alertService: AlertService,
              private _lps: LoadingPanelService, private _fet: FirmaElectronicaTokenService) {
    this.configureForm()
    this.configureEmpresaCreateForm();
    this.usuarioTieneFirmaElectronicaActiva();
  }

  ngOnInit() {
    this.getInformacionUsuario();
    this.translate().then(() => {
      this.titleModal = this._translations?.tituloEmpresa;
      this.getPropsTable()
    });
    this.getTipoIdentificaciones();
    this.getPaises();

  }

  ngAfterViewInit(): void {
    this.getEmpresas();
  }


  private async translate(): Promise<void> {
    this._translations = await firstValueFrom(forkJoin({
      completeCampos: this._t.get('form.msg.complete-campos'),
      warnSummary: this._t.get('form.msg.warn-summary'),
      registrarExito: this._t.get('components.app-authentication-manager.register-form.registrar-exito'),
      aceptar: this._t.get('form.button.aceptar'),
      tituloEmpresa: this._t.get('components.app-authentication-manager.profile-form.modificar-empresa'),
      columnNit: this._t.get('components.app-authentication-manager.profile-form.nit'),
      columnRazonSocial: this._t.get('components.app-authentication-manager.profile-form.razon-social'),
      modificacionExitosa: this._t.get('components.app-authentication-manager.profile-form.modificacion-exitosa'),
      empresa: this._t.get('common.empresa'),

      seleccionar: this._t.get('common.seleccionar'),
      registrar: this._t.get('components.app-efectuar-tramite-empresa-form.registrar'),
      razonSocial: this._t.get('components.app-efectuar-tramite-empresa-form.nombre'),
      nit: this._t.get('components.app-efectuar-tramite-empresa-form.nit'),
      direccion: this._t.get('common.direccion'),
      telefono: this._t.get('common.telefono'),
      correo: this._t.get('common.correo'),
      documento: this._t.get('common.documento'),
      invalidSize: this._t.get('form.msg.invalid-size'),
      campoRequerido: this._t.get('form.msg.campo-requerido'),
      archivo: this._t.get('common.archivo'),
      wasUploaded: this._t.get('form.msg.was-uploaded'),
      agregarDocumento: this._t.get('form.button.agregar-documento'),
      btnActualizar: this._t.get('form.button.actualizar'),
      limpiar: this._t.get('form.button.limpiar'),
      empresaRegistrada: this._t.get('components.app-authentication-manager.profile-form.empresa-actualizada'),
      empresaRegistradaMsg: this._t.get('components.app-authentication-manager.profile-form.empresa-actualizada-msg'),

    }));

  }

  onPaisChange(event: IPais) {
    this.form.get('departamentoExpedicionId')?.setValue(null);
    this.form.get('municipioExpedicionId')?.setValue(null);
    this.form.get('otroPaisExpedicion')?.setValue('');
    this.form.get('otroDepartamentoExpedicion')?.setValue('');
    this.form.get('otroMunicipioExpedicion')?.setValue('');
    this.municipios = [];
    this.getDepartamentos();
  }

  onDepartamentoChange(event: IDepartamento) {
    this.form.get('municipioExpedicionId')?.setValue(null);
    this.form.get('otroPaisExpedicion')?.setValue('');
    this.form.get('otroDepartamentoExpedicion')?.setValue('');
    this.form.get('otroMunicipioExpedicion')?.setValue('');
    this.getMunicipios();
  }

  getTipoIdentificaciones() {
    this._ti.getTipoIdentificaciones().subscribe({
      next: (response: ITipoIdentificacion[]) => {
        this.tipoIdentificaciones = response?.filter(t => !this.ignoreTipoIdentificacion?.includes(t.abreviatura));
      }
    });
  }

  getPaises() {
    this._p.getPaises().subscribe({
      next: (response: IPais[]) => {
        this.paises = response;
      }
    });
  }

  getDepartamentos() {
    const paisId :IPais= this.form.get('paisExpedicionId')?.value;
    this._d.getDepartamentos(paisId.id).subscribe({
      next: (response: IDepartamento[]) => {
        this.departamentos = response;
      }
    });
  }

  getMunicipios() {
    const paisId :IPais = this.form.get('paisExpedicionId')?.value;
    const departamentoId : IDepartamento  = this.form.get('departamentoExpedicionId')?.value;
    this._m.getMunicipios(paisId.id, departamentoId.id).subscribe({
      next: (response: IMunicipio[]) => {
        this.municipios = response;
      }
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      Utils.markAllFormControlsAsTouched(this.form);
      this._ms.add({ severity: 'warn', summary: this._translations.warnSummary, detail: this._translations.completeCampos });
      return;
    }

    const request = {
      tipoIdentificacionId: this.form.get('tipoIdentificacionId')?.value,
      identificacion: this.form.get('identificacion')?.value,
      primerNombre: this.form.get('primerNombre')?.value,
      segundoNombre: this.form.get('segundoNombre')?.value,
      primerApellido: this.form.get('primerApellido')?.value,
      segundoApellido: this.form.get('segundoApellido')?.value,
      correoElectronico: this.form.get('correoElectronico')?.value,
      telefono: this.form.get('telefono')?.value,
      direccion: this.form.get('direccion')?.value,
      fechaExpedicion: this.form.get('fechaExpedicion')?.value,
      paisExpedicionId: this.form.get('paisExpedicionId')?.value.id,
      departamentoExpedicionId: this.form.get('departamentoExpedicionId')?.value?.id,
      municipioExpedicionId: this.form.get('municipioExpedicionId')?.value?.id,
      otroPaisExpedicion: this.form.get('otroPaisExpedicion')?.value,
      otroDepartamentoExpedicion: this.form.get('otroDepartamentoExpedicion')?.value,
      otroMunicipioExpedicion: this.form.get('otroMunicipioExpedicion')?.value,
    } as RegistrarUsuarioRequest;

    this.updateUsuario(request);
  }

  configureForm() {
    this.form = this._fb.group({
      primerNombre: [null, [Validators.required, Validators.maxLength(50), noWhitespaceValidator]],
      segundoNombre: [null, [Validators.maxLength(50)]],
      primerApellido: [null, [Validators.required, Validators.maxLength(50), noWhitespaceValidator]],
      segundoApellido: [null, [Validators.maxLength(50)]],
      telefono: [null, [Validators.required, Validators.maxLength(60), noWhitespaceValidator]],
      correoElectronico: [null, [Validators.required, Validators.email, Validators.maxLength(100), noWhitespaceValidator]],
      direccion: [null, [Validators.required, Validators.maxLength(200), noWhitespaceValidator]],
      tipoIdentificacionId: [null, Validators.required],
      identificacion: [null, [Validators.required, Validators.maxLength(20)]],
      paisExpedicionId: [null, [Validators.required]],
      departamentoExpedicionId: [null],
      municipioExpedicionId: [null],
      otroPaisExpedicion: [null, [Validators.maxLength(100)]],
      otroDepartamentoExpedicion: [null, [Validators.maxLength(100)]],
      otroMunicipioExpedicion: [null, [Validators.maxLength(100)]],
      fechaExpedicion: [null, [Validators.required]],
    });
  }

  get isOtroPaisExpedicion() {
    return this.form.get('paisExpedicionId')?.value?.descripcion === "OTRO";
  }

  get isOtroDepartamentoExpedicion() {
    return this.form.get('departamentoExpedicionId')?.value?.descripcion === "OTRO";
  }

  get isOtroMunicipioExpedicion() {
    return this.form.get('municipioExpedicionId')?.value?.descripcion === "OTRO";
  }

  async getInformacionUsuario():Promise<void> {
    this.loading = true;
    return await lastValueFrom(this._pu.getInformacionPerfilUsuario()).then(result => {
      this.infoProfile = result;
      this.addDataToForm();
      this.loading = false;
    })
  }

  addDataToForm() {
    this.form.patchValue({
      primerNombre: this.infoProfile.primerNombre,
      segundoNombre: this.infoProfile.segundoNombre,
      primerApellido: this.infoProfile.primerApellido,
      segundoApellido: this.infoProfile.segundoApellido,
      telefono: this.infoProfile.telefono,
      correoElectronico: this.infoProfile.correo,
      direccion: this.infoProfile.direccion,
      tipoIdentificacionId: this.infoProfile.tipoIdentificacion,
      identificacion: this.infoProfile.identificacion,
      otroPaisExpedicion: this.infoProfile.otroPais,
      otroDepartamentoExpedicion: this.infoProfile.otroDepartamento,
      otroMunicipioExpedicion: this.infoProfile.otroMunicipio,
    });

    if (this.infoProfile.fechaExpedicion){
      this.form.get('fechaExpedicion')?.setValue(new Date(this.infoProfile.fechaExpedicion));
    }

    if (this.infoProfile.pais) {
      this.form.get('paisExpedicionId')?.setValue({
        descripcion: this.infoProfile.paisDescripcion,
        id: this.infoProfile.pais
      } as IPais);
      this.getDepartamentos();
    }
    if (this.infoProfile.departamento) {
      this.form.get('departamentoExpedicionId')?.setValue({
        id: this.infoProfile.departamento,
        descripcion: this.infoProfile.departamentoDescripcion
      } as IDepartamento);
      this.getMunicipios();
    }
    if (this.infoProfile.municipio) {
      this.form.get('municipioExpedicionId')?.setValue(
        {
          id: this.infoProfile.municipio,
          descripcion: this.infoProfile.municipioDescripcion
        } as IMunicipio);
    }
  }

  cancel() {
    this.modoEdicion = false;
    this.getInformacionUsuario();
  }

  editar() {
    this.modoEdicion = true;
  }

  getPropsTable() {
    this.propsTable = {
      columns: [
        {
          field: 'nombre',
          header: this._translations.columnRazonSocial,
          class: 'font-16 text-gray-600',
          columnmHeader: {
            class: 'text-left color-blue-2 font-bold',
            style: ''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'nit',
          header: this._translations.columnNit,
          class: 'font-16 text-gray-600',
          columnmHeader: {
            class: 'text-left color-blue-2  font-bold',
            style: ''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        }, {
          field: 'direccion',
          header: this._translations.direccion,
          class: 'font-16 text-gray-600',
          columnmHeader: {
            class: 'text-left color-blue-2 font-bold',
            style: ''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        }, {
          field: 'correo',
          header:this._translations.correo,
          class: 'font-16 text-gray-600',
          columnmHeader: {
            class: 'text-left color-blue-2  font-bold',
            style: ''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        }, {
          field: 'telefono',
          header: this._translations.telefono,
          class: 'font-16 text-gray-600',
          columnmHeader: {
            class: 'text-left color-blue-2  font-bold',
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'abrir',
          header: '', // icon: 'pi pi-pencil',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.EDIT,
          onClick: (event: Event, data: Required<PortalUsuarioEmpresaDto>) => this.editEmpresa(data),
        },
      ],
      settings: {
        table: {
          rows: 6,

        }
      }
    } as ICustomTable
  }

  getEmpresas() {
    if (!this.empresasTable) return;
    this.empresasTable.isLoading = true;
    this._portalEmpService.getDetalleEmpresasByUsuarioId().subscribe({
      next: value => {
        this.empresasTable.data = value;
      }, complete: () => {
        this.empresasTable.isLoading = false;
      }
    })
  }

  configureEmpresaCreateForm() {
    this.empresaCreate = this._fb.group({
      nombre: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      nit: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(50)]],
      direccion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      telefono: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(20)]],
      correo: [null, [Validators.required, noWhitespaceValidator, Validators.email, Validators.maxLength(100)]],
    });
  }

  editEmpresa(value: PortalUsuarioEmpresaDto) {
    this.openModal = true;
    this.idEmpresaSelected = value.id;
    this.empresaCreate.patchValue({
      nombre: value.nombre,
      nit: value.nit,
      direccion: value.direccion,
      telefono: value.telefono,
      correo: value.correo
    })
  }

  onEmpresaCreateSubmit() {
    if (this.empresaCreate.invalid) {
      Utils.markAllFormControlsAsTouched(this.empresaCreate);

      this._ms.add({
        severity: 'warn',
        summary: this._translations.warnSummary,
        detail: this._translations.completeCampos
      });
      return;
    }

    let request: PortalUsuarioEmpresaDto = {
      nombre: this.empresaCreate.get('nombre')?.value,
      nit: this.empresaCreate.get('nit')?.value,
      direccion: this.empresaCreate.get('direccion')?.value,
      telefono: this.empresaCreate.get('telefono')?.value,
      correo: this.empresaCreate.get('correo')?.value,
    }

    this.updateEmpresa(request);
  }

  get isMunicipioExpedicionIdVisible() {
    if (this.isOtroPaisExpedicion) {
      return false;
    }
    if (this.isOtroDepartamentoExpedicion) {
      return false;
    }
    return true;
  }

  get firstLetterName() {
    return this.infoProfile?.nombreCompleto?.[0]?.toUpperCase() || 'N';
  }

  private updateEmpresa(request: PortalUsuarioEmpresaDto) {
    if (!this.idEmpresaSelected) return;
    this._lps.show();
    this._portalEmpService.actualizaEmpresa(request, this.idEmpresaSelected, this.archivo).subscribe({
      next: (response: number) => {
        this._ms.add({
          severity: 'success',
          summary: this._translations.empresaRegistrada,
          detail: this._translations.empresaRegistradaMsg
        });
        this._lps.hide();
        this.openModal = false;
      }, complete: () => {
        this.getEmpresas();
      }
    });
  }

  updateUsuario(request: RegistrarUsuarioRequest) {
    this._lps.show();
    this._pu.actualizarUsuario(request).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this.alertService.show({
          data:{
            icon:AlertIcon.INFO,
            title:this._translations.modificacionExitosa,
            showAccept:true,
            textAccept:this._translations.aceptar
          },
          autoClose: true,
          timer: 3500
        }).subscribe((event)=>{
          this.cancel()
        });
      }
    });

  }

  uploadHandler(event: FileUploadHandlerEvent, fileUpload: FileUpload) {
    const file = event.files[0];
    this.invalidSize = false;
    //validate file size
    if (file.size > (1024 * 1024)) {
      this.invalidSize = true;
      fileUpload.clear();
      return;
    }
    this.archivo = file;
    fileUpload.clear();
    this.requieredFile = false;
  }

  removeFile() {
    this.archivo = undefined;
    this.invalidSize = false;
  }

  onLimpiarDatos() {
    this.empresaCreate.reset();
    this.removeFile();
  }

  onHideModal(){
    this.idEmpresaSelected = undefined;
    this.onLimpiarDatos();
  }

  usuarioTieneFirmaElectronicaActiva() {
    this._lps.show(true);
    this._fet.usuarioTieneFirmaElectronicaActiva().subscribe({
      next: (response: boolean) => {
        this.usuarioTieneFirmaActiva = response;
        if(this.usuarioTieneFirmaActiva){
          this.form.get('correoElectronico')?.disable();
        }
      }, complete: () => {
        this._lps.hide();
      }
    });
  }

}

